/**
 * @overview Avatar component
 */
import cx from 'classnames';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { Image } from '../image/index';
import { Typography } from '../typography';
import styles from './avatar.module.scss';
import { getRandomBgClassNameFromName } from './avatar-util';
import { AvatarGrid } from './grid';
import { AvatarTray } from './tray';
function onError(setImageExist) {
    setImageExist(false);
}
export const Avatar = ({ name, id, className = '', src = '', showName = false, namePosition = 'right', size = 'm', disabled = false, nameWithPrefix = '', showNameWithPrefixOnTooltip = false, isNameLink = false, showTooltip = true, badgeValue = undefined, showBadge = false, suffixText = '', showTooltipOnEllipsis = false, ...restProps }) => {
    const rootClassNames = cx(styles.root, className, styles[`size-${size}`], namePosition === 'right' ? styles.nameRight : styles.nameBottom, {
        [styles.disabled]: disabled,
    });
    const [isImageExists, setIsImageExists] = React.useState(!!src);
    useEffect(() => {
        setIsImageExists(!!src);
    }, [src]);
    const [isImageLoaded, setIsImageLoaded] = React.useState(false);
    const randomBgClassName = getRandomBgClassNameFromName(id || name);
    const tooltipProps = showTooltip
        ? {
            'data-tooltip-content': showNameWithPrefixOnTooltip && nameWithPrefix
                ? nameWithPrefix
                : name,
            'data-tooltip-position': 'center',
            'data-tooltip-align': 'top',
        }
        : {};
    const renderText = () => {
        const variants = {
            xs: 'body-large',
            s: 'footnote',
            m: 'body-normal',
            l: 'body-large',
        };
        const variantName = variants[size];
        return (showName &&
            name && (React.createElement(React.Fragment, null,
            React.createElement(Typography, { variant: variantName, className: cx(styles.name, {
                    [styles.nameLink]: isNameLink,
                }), ellipsis: showTooltipOnEllipsis ? { rows: 1 } : undefined }, nameWithPrefix || name),
            suffixText && (React.createElement(Typography, { variant: variantName, noMargin: true },
                "\u00A0+",
                suffixText)))));
    };
    return (React.createElement("div", { id: id, className: rootClassNames, ...restProps },
        React.createElement("div", { className: styles.avatarContainer },
            React.createElement("div", { className: styles.avatar, ...tooltipProps },
                name && (!isImageExists || !isImageLoaded) && (React.createElement("span", { className: cx(styles.initial, styles[randomBgClassName]) }, name[0])),
                src && isImageExists && (React.createElement(Image, { loading: "lazy", className: cx(styles.avatarImage, {
                        [styles.loaded]: isImageLoaded,
                    }), alt: name, onImageLoadError: () => {
                        onError(setIsImageExists);
                    }, onLoad: () => {
                        setIsImageLoaded(true);
                    }, src: src }))),
            !_.isUndefined(badgeValue) && (React.createElement("span", { className: cx(styles.badge) }, badgeValue < 100 ? badgeValue : 99)),
            showBadge && _.isUndefined(badgeValue) && (React.createElement("span", { className: cx(styles.badge, styles.dotBadge) }))),
        showTooltipOnEllipsis ? (React.createElement("div", { className: cx(styles.textWrapper) }, renderText())) : (renderText())));
};
Avatar.Grid = AvatarGrid;
Avatar.Tray = AvatarTray;
//# sourceMappingURL=avatar.js.map